// @react
import React from 'react'
// @design
// @components
import DocumentTitle from 'react-document-title'
import Grid from '@bit/atd.web.grid'
import PageWrapper from 'modules/activityHistory/components/PageWrapper'
import Content from 'modules/activityHistory/components/UserContent'
import PageTitle from '@bit/atd.web.page-title'
import Button from '@bit/atd.web.button'
import Spacer from '@bit/atd.web.spacer'
import Icon from '@bit/atd.web.icons'
import { ExternalRouteNames } from 'constants/routeNames'

/**
 * 4.0.4 My ATD - Activity History - User Content
 * https://www.figma.com/file/jCo0D2EYkVbuBX1TjR1enA/ATD-MyATD-Desktop-2020?node-id=2507%3A7294
 */

type PropsType = any
const title = 'Activity History - User Content'

const UserContent = (props: PropsType) => {
  /******************************************
   * PROPS
   ******************************************/

  /******************************************
   * STATE
   ******************************************/

  /******************************************
   * HOOKS
   ******************************************/

  /******************************************
   * FUNCTIONS
   ******************************************/

  return (
    <PageWrapper>
      <DocumentTitle title={`${title} | ATD`}>
        <>
          <PageTitle>
            <Grid
              container
              direction="row"
              justify="space-between"
              alignItems="flex-start"
            >
              <Grid item>My Contributions</Grid>
              <Grid item>
                <Button
                  variant="primary"
                  size="small"
                  href={ExternalRouteNames.ATD_CONTRIBUTE}
                >
                  <>
                    <Icon glyph="add" size={16} />
                    <Spacer size={4} />
                    Contribute
                  </>
                </Button>
              </Grid>
            </Grid>
          </PageTitle>
          <Content />
        </>
      </DocumentTitle>
    </PageWrapper>
  )
}

export default UserContent
